import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import CreateProposal from "modules/proposals/CreateProposal";
import { CreateProposalFormHandle } from "modules/proposals/forms/CreateProposalForm";
import TourHelpButton from "components/PageTour/TourHelpButton";
import { useRef } from "react";

export default function ProposalCreatePage() {
  const tourRef = useRef<CreateProposalFormHandle>(null);

  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography
              variant="h4"
              fontWeight="medium"
              display="flex"
              alignItems="center"
              gap={1}
            >
              Create Proposal
              <TourHelpButton
                tooltip="Click here to learn more about Creating a Proposal"
                onClick={() => tourRef.current?.replay()}
              />
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CreateProposal ref={tourRef} />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
